module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('TopNavFooter', [_c('div', {
    staticClass: "main-content",
    attrs: {
      "id": "admin"
    }
  }, [_c('spinner', {
    attrs: {
      "spinnerOn": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal dxpNewmodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.activationTemplateTitle) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.dxpNewmodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.activationTemplateDescription) + "\n                ")])]), _vm._v(" "), _vm._l((_vm.dxpList), function(data, ind) {
    return _c('div', {
      key: ind,
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation"
      },
      domProps: {
        "value": data.id
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(" " + _vm._s(data.label) + " " + _vm._s(_vm.user_lang.template))])])
  }), _vm._v(" "), _vm._l((_vm.nonDxpList), function(data, ind) {
    return _c('div', {
      key: ind,
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation",
        "checked": "checked"
      },
      domProps: {
        "value": 0
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(_vm._s(_vm.user_lang.cargillActivation))])])
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendDxpNewInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal newdxpmodal1",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.activationTitle) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.newdxpmodal1')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.activationDescription) + "\n                ")])]), _vm._v(" "), _vm._l((_vm.dxpList), function(data, ind) {
    return _c('div', {
      key: ind,
      staticStyle: {
        "margin-right": "233px",
        "width": "100%",
        "text-align": "left"
      }
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": data.id,
        "name": "activation"
      },
      domProps: {
        "value": data.id
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": data.id
      }
    }, [_vm._v(" " + _vm._s(data.label) + " " + _vm._s(_vm.user_lang.template))])])
  }), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.sendDxpNewInvite($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.activationOk))])], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal mfaresetmodal",
    staticStyle: {
      "z-index": "9999"
    },
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "modal-header",
    staticStyle: {
      "display": "block"
    }
  }, [_c('div', {
    staticClass: "col-lg-9 col-md-9 col-sm-9 col-xs-9",
    staticStyle: {
      "font-weight": "bold",
      "float": "left",
      "width": "90%"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.mfaResetModalTitle) + "\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.mfaresetmodal')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "font-size": "18px"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [(!_vm.isAuthorizedForMFA) ? _c('div', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.errorMsgForMFA))]) : _vm._e(), _vm._v(" "), (_vm.mfaResetSuccess) ? _c('div', {
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.factorResetSuccess))]) : _vm._e(), _vm._v(" "), (_vm.isAuthorizedForMFA && !_vm.mfaResetSuccess) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-right": "233px",
      "width": "100%",
      "text-align": "left"
    }
  }, [_c('label', {
    staticClass: "form-control-label col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "font-size": "18px",
      "font-weight": "normal !important"
    },
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.user_lang.resetConfirmation) + "\n                  ")])]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.resetMFA($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.yes))]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-primary btn-block btn-lg col-lg-12 col-md-12 col-sm-12 col-xs-12",
    staticStyle: {
      "margin-top": "15px"
    },
    attrs: {
      "href": "#",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.mfaresetmodal')
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.no))])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "background": "#fff",
      "padding": "0px",
      "padding-top": "35px"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "modal bulkReinviteMessageModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "top": "100px"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "bulk-upload-header",
    staticStyle: {
      "float": "left",
      "padding": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  Bulk Reinvite Message\n                  "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "color": "#fff"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._v("\n                  " + _vm._s(_vm.reInviteMessage) + "\n                ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal bulkUploadOptionsModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "top": "100px"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "bulk-upload-header",
    staticStyle: {
      "float": "left",
      "padding": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.bulkUploadOptionsLabel) + "\n                  ")]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "padding": "10px 20px 5px"
    }
  }, [_c('div', {
    staticClass: "checkboxgroup"
  }, [_c('input', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "name": "bulkUpload",
      "id": "bulkCreate"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding-left": "7px",
      "font-weight": "normal"
    },
    attrs: {
      "for": "bulkCreate"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.bulkCreateUsers))])]), _vm._v(" "), _c('div', {
    staticClass: "checkboxgroup"
  }, [_c('input', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "type": "radio",
      "name": "bulkUpload",
      "id": "bulkReinvite"
    }
  }), _vm._v(" "), _c('label', {
    staticStyle: {
      "padding-left": "7px",
      "font-weight": "normal"
    },
    attrs: {
      "for": "bulkReinvite"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.bulkReinviteUsers))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openbulkModals()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.confirm))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('.bulkUploadOptionsModal');
        _vm.clearSelectedOptions();
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.user_lang.cancel) + "\n                    ")])]), _vm._v(" "), (_vm.optionsNotSelected) ? _c('div', {
    staticStyle: {
      "color": "#ff0000",
      "padding": "10px 20px 5px"
    }
  }, [_vm._v("Please select an option to proceed.")]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal bulkReinviteModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "top": "100px"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "bulk-upload-header",
    staticStyle: {
      "float": "left",
      "padding": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.bulkReinviteUsers) + "\n                  "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "color": "#fff"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.clearSelectedOptions()
      }
    }
  }, [_vm._v("\n                    ×\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.user_lang.downloadExcelTemplate) + "\n                    "), _c('a', {
    attrs: {
      "href": "../../static/Reinvite_template.xlsx",
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "25px",
      "margin-left": "10px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "15px",
      "color": "#000",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.uploadInstruction))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0px 0px 10px 20px"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningOne))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningTwo))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningThree))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.user_lang.note))]), _vm._v(" " + _vm._s(_vm.user_lang.uploadNote) + "\n                    ")])]), _vm._v(" "), (_vm.adminType === 'admin' || _vm.adminType === 'superadmin') ? _c('div', {
    staticStyle: {
      "font-size": "14px",
      "padding-right": "30px",
      "background": "#eceff1",
      "padding": "12px 15px",
      "vertical-align": "-webkit-baseline-middle"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.user_lang.bulkReinviteUsers) + ":\n                    "), (_vm.uploadReady) ? _c('input', {
    ref: "reinviteFile",
    staticStyle: {
      "border": "none !important",
      "padding": "0px !important",
      "color": "#000 !important",
      "width": "220px",
      "background": "transparent !important"
    },
    attrs: {
      "type": "file",
      "id": "reinviteFile"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload(true)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    class: {
      disabled: !_vm.isExcel
    },
    staticStyle: {
      "padding": "5px 10px",
      "font-size": "14px !important",
      "font-weight": "bold"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submitFile(true)
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.user_lang.uploadLabel) + "\n                    ")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal bulkCreateModal",
    attrs: {
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    staticStyle: {
      "top": "100px"
    }
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "color": "#00524a"
    }
  }, [_c('div', {
    staticClass: "bulk-upload-header",
    staticStyle: {
      "float": "left",
      "padding": "10px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.bulkCreateUsers) + "\n                  "), _c('button', {
    staticClass: "close",
    staticStyle: {
      "text-align": "right",
      "color": "#fff"
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.clearSelectedOptions()
      }
    }
  }, [_vm._v("\n                    ×\n                  ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.user_lang.downloadExcelTemplate) + "\n                    "), _c('a', {
    attrs: {
      "href": "../../static/template.xlsx",
      "download": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "25px",
      "margin-left": "10px"
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "15px",
      "color": "#000",
      "font-size": "14px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.uploadInstruction))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "0px 0px 10px 20px"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningOne))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningFour))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningFive))]), _vm._v(" "), _c('div', [_c('i', {
    staticClass: "fa fa-exclamation-triangle bulk-upload-warning"
  }), _vm._v(_vm._s(_vm.user_lang.uploadWarningSix))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.user_lang.note))]), _vm._v(" " + _vm._s(_vm.user_lang.uploadNote) + "\n                    ")])]), _vm._v(" "), (_vm.adminType === 'admin' || _vm.adminType === 'superadmin') ? _c('div', {
    staticStyle: {
      "font-size": "14px",
      "padding-right": "30px",
      "background": "#eceff1",
      "padding": "12px 15px",
      "vertical-align": "-webkit-baseline-middle"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.user_lang.bulkCreateUsers) + ":\n                    "), (_vm.uploadReady) ? _c('input', {
    ref: "file",
    staticStyle: {
      "border": "none !important",
      "padding": "0px !important",
      "color": "#000 !important",
      "width": "220px",
      "background": "transparent !important"
    },
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": function($event) {
        _vm.handleFileUpload(false)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    class: {
      disabled: !_vm.isExcel
    },
    staticStyle: {
      "padding": "5px 10px",
      "font-size": "14px !important",
      "font-weight": "bold"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.submitFile(false)
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.user_lang.uploadLabel) + "\n                    ")])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShow || _vm.updateToggle),
      expression: "isShow || updateToggle"
    }],
    staticStyle: {
      "margin": "-15px"
    }
  }, [_c('div', {
    staticClass: "bc-adduser"
  }, [_c('span', {
    staticClass: "bc-nav",
    on: {
      "click": function($event) {
        _vm.goToUserManagement()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.userAdministration))]), _vm._v("  /  "), _c('span', [_vm._v(" " + _vm._s(_vm.updateToggle ? _vm.user_lang.edituser : _vm.user_lang.adduser))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "15px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.updateToggle ? _vm.user_lang.edituser : _vm.user_lang.adduser))])]), _vm._v(" "), _vm._l((_vm.addUserValidations), function(i, ind) {
    return _c('div', {
      key: ind,
      staticClass: "error-bg usercreateinfo",
      staticStyle: {
        "margin-top": "10px"
      },
      attrs: {
        "id": "formValidation"
      }
    }, [_c('div', [_c('i', {
      staticClass: "fa fa-close",
      staticStyle: {
        "float": "right",
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.addUserValidations = []
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticStyle: {
        "display": "inline-block",
        "margin": "5px 5px"
      }
    }, [_c('i', {
      staticClass: "fa fa-info-circle",
      staticStyle: {
        "font-size": "25px"
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(i))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "card-block",
    staticStyle: {
      "background": "#f1f1f1 !important",
      "margin-bottom": "10px",
      "padding": "18px 18px"
    }
  }, [_c('div', {
    staticClass: "user-creds"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.first_name) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserFirstName),
      expression: "addUserFirstName"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.isNameEditable && _vm.updateToggle
    },
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.addUserFirstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserFirstName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.last_name) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserLastName),
      expression: "addUserLastName"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: !_vm.isNameEditable && _vm.updateToggle
    },
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.addUserLastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserLastName = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.primary_mail) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserPrimaryEmail),
      expression: "addUserPrimaryEmail"
    }],
    staticClass: "form-control input-adduser",
    class: {
      disabled: _vm.updateToggle
    },
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.addUserPrimaryEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserPrimaryEmail = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.secondary_mail) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.addUserSecondaryEmail),
      expression: "addUserSecondaryEmail"
    }],
    staticClass: "form-control input-adduser",
    attrs: {
      "id": "message-text"
    },
    domProps: {
      "value": (_vm.addUserSecondaryEmail)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.addUserSecondaryEmail = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12"
  }, [_c('div', {
    class: {
      disabled: _vm.updateToggle
    }
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectLang) + ":")]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.prefLang),
      expression: "prefLang"
    }],
    staticClass: "preflang",
    staticStyle: {
      "height": "39px"
    },
    attrs: {
      "id": "message-text"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.prefLang = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.lang_def), function(i, ind) {
    return _c('option', {
      key: ind,
      domProps: {
        "value": i.langCode
      }
    }, [_vm._v(_vm._s(i.langName))])
  }))])])])])]), _vm._v(" "), (_vm.isEdit) ? _c('div', {
    staticClass: "user-creds",
    staticStyle: {
      "padding-bottom": "7px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "5px 15px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "15px",
      "width": "100%"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.viewMoreInfo))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.infoContent,
      "data-original-title": _vm.user_lang.infoContent
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "padding": "3px 10px",
      "font-size": "20px",
      "cursor": "pointer"
    },
    attrs: {
      "id": "toggle-arrow"
    },
    on: {
      "click": _vm.toggleDateFields
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "none"
    },
    attrs: {
      "id": "toggle-data"
    }
  }, [_c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.createdDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.createdDateDescription,
      "data-original-title": _vm.user_lang.createdDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.createdDate))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.activatedDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.activatedDateDescription,
      "data-original-title": _vm.user_lang.activatedDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.activatedDate))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.lastLoginDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.lastLoginDateDescription,
      "data-original-title": _vm.user_lang.lastLoginDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.lastLogin))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.lastUpdatedDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.lastUpdatedDateDescription,
      "data-original-title": _vm.user_lang.lastUpdatedDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.lastUpdated))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.passwordChangedDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.passwordChangedDateDescription,
      "data-original-title": _vm.user_lang.passwordChangedDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.passwordChanged))])]), _vm._v(" "), _c('div', {
    staticClass: "row date-field-edit"
  }, [_c('label', [_vm._v(_vm._s(_vm.user_lang.statusChangedDate))]), _vm._v(" "), _c('span', {
    staticClass: "fa fa-info-circle date-info",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.user_lang.statusChangedDateDescription,
      "data-original-title": _vm.user_lang.statusChangedDateDescription
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "separator"
  }, [_c('b', [_vm._v(": ")])]), _vm._v(" "), _c('div', {
    staticClass: "date-value-edit",
    attrs: {
      "col": "3"
    }
  }, [_vm._v(_vm._s(_vm.dateInfo.statusChanged))])])])])]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('div', {
    staticClass: "user-creds",
    staticStyle: {
      "padding-bottom": "7px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding": "5px 15px 0px"
    }
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "padding-left": "15px",
      "width": "100%"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetMFATitle))]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right",
    staticStyle: {
      "padding": "3px 10px",
      "font-size": "20px",
      "cursor": "pointer"
    },
    attrs: {
      "id": "toggle-mfa-arrow"
    },
    on: {
      "click": _vm.toggleMFAField
    }
  })]), _vm._v(" "), (_vm.userFactorList.length === 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "none",
      "padding": "5px"
    },
    attrs: {
      "id": "toggle-mfa-data"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.user_lang.noFactorExist) + "\n                  ")]) : _vm._e(), _vm._v(" "), (_vm.userFactorList.length > 0) ? _c('div', {
    staticStyle: {
      "width": "100%",
      "display": "none",
      "padding": "5px"
    },
    attrs: {
      "id": "toggle-mfa-data"
    }
  }, [_vm._l((_vm.userFactorList), function(factor) {
    return _c('div', {
      key: factor.id,
      staticClass: "mfa-list"
    }, [_c('div', {
      staticClass: "checkboxgroup"
    }, [_c('input', {
      staticStyle: {
        "width": "20px",
        "height": "20px"
      },
      attrs: {
        "type": "radio",
        "name": "mfaReset",
        "id": factor.id
      }
    }), _vm._v(" "), _c('label', {
      staticStyle: {
        "padding-left": "7px",
        "font-weight": "normal"
      },
      attrs: {
        "for": factor.id
      }
    }, [_vm._v(_vm._s(factor.factorType.indexOf("token:software:totp") > -1 ? _vm.transformText(factor.provider) : _vm.transformText(factor.factorType)))])])])
  }), _vm._v(" "), (_vm.noFactorSelected) ? _c('div', {
    staticClass: "validation-mfa"
  }, [_vm._v(_vm._s(_vm.user_lang.mfaValidation))]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mfa-btn",
    on: {
      "click": _vm.checkAccess
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetButton))])], 2) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user-creds"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang["assignApplication"]))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('div', {
    attrs: {
      "id": "dropdown"
    }
  }, [_c('div', {
    staticClass: "selectDropDown",
    on: {
      "click": function($event) {
        _vm.showDropDown = !_vm.showDropDown
      }
    }
  }, [_c('span', {
    staticStyle: {
      "padding-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang["selectgroups"])), _c('i', {
    staticClass: "fa fa-caret-down",
    staticStyle: {
      "float": "right",
      "margin": "4px 5px"
    }
  })])]), _vm._v(" "), _vm._l((_vm.adminToBrands), function(n, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (
          _vm.showDropDown &&
          (_vm.appUrl.indexOf('identity-dev') > -1 ||
            _vm.appUrl.indexOf('cargill') > -1 ||
            (n.toLowerCase() !== 'cargill' && _vm.appUrl.indexOf(n.toLowerCase().replace('portal', '')) > -1) ||
            _vm.appUrl.indexOf('localhost') > -1)
        ),
        expression: "\n                            showDropDown &&\n                            (appUrl.indexOf('identity-dev') > -1 ||\n                              appUrl.indexOf('cargill') > -1 ||\n                              (n.toLowerCase() !== 'cargill' && appUrl.indexOf(n.toLowerCase().replace('portal', '')) > -1) ||\n                              appUrl.indexOf('localhost') > -1)\n                          "
      }],
      key: index,
      class: {
        disabled: _vm.checkedAppBrand !== '' && n.toLowerCase() !== _vm.checkedAppBrand.toLowerCase()
      }
    }, [_c('span', {
      staticClass: "admintobrand"
    }, [_vm._v(_vm._s(n))]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showDropDown),
        expression: "showDropDown"
      }],
      attrs: {
        "id": "checkboxlist"
      }
    }, _vm._l((_vm.uniqueAppsFiltered), function(app, index) {
      return _c('div', {
        key: index,
        staticClass: "dd-list-item",
        staticStyle: {
          "padding-right": "15px",
          "padding-left": "5px"
        }
      }, [(n === app.brand) ? _c('div', [_c('input', {
        staticClass: "form-control input-checkbx",
        attrs: {
          "type": "checkbox",
          "id": app.appGrpId
        },
        domProps: {
          "value": app.groupId + '-' + app.adminGroupName
        }
      }), _vm._v(" "), _c('label', {
        staticStyle: {
          "vertical-align": "super",
          "display": "inline"
        },
        attrs: {
          "for": app.appGrpId
        }
      }, [_vm._v(_vm._s(app.applicationName) + "\n                                  ")])]) : _vm._e()])
    }))])
  })], 2)])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.brand !== ''),
      expression: "brand !== ''"
    }],
    staticClass: "col-lg-4 col-md-4 col-sm-6 col-xs-12",
    staticStyle: {
      "padding-top": "5px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.selectedBrand) + " ")]), _c('span', {
    staticStyle: {
      "text-transform": "capitalize"
    }
  }, [_vm._v(_vm._s(_vm.brand))])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang["availablegroups"]) + ":")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, _vm._l((_vm.availablegroups), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "group-div",
      class: {
        disabled: i.isReadOnly, bb0: index !== _vm.availablegroups.length - 1
      }
    }, [_c('div', {
      staticStyle: {
        "pointer-events": "auto",
        "cursor": "default"
      },
      attrs: {
        "data-toggle": i.isReadOnly ? 'tooltip' : false,
        "title": _vm.disableAvailableGroups(i.isReadOnly),
        "data-original-title": _vm.disableAvailableGroups(i.isReadOnly)
      }
    }, [_c('div', {
      staticClass: "group-name"
    }, [_vm._v(_vm._s(i.subGroupName))]), _vm._v(" "), (!i.isReadOnly) ? _c('i', {
      staticClass: "fa fa-plus-circle add-group",
      on: {
        "click": function($event) {
          _vm.addToSelectedGroup(i.subGroupId)
        }
      }
    }) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.availableIndependentGroups))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, _vm._l((_vm.indieGroupsForNewUser), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "group-div",
      class: {
        disabled: i.isReadOnly
      }
    }, [_c('div', {
      staticStyle: {
        "pointer-events": "auto",
        "cursor": "default"
      },
      attrs: {
        "data-toggle": i.isReadOnly ? 'tooltip' : false,
        "title": _vm.disableAvailableGroups(i.isReadOnly),
        "data-original-title": _vm.disableAvailableGroups(i.isReadOnly)
      }
    }, [_c('div', {
      staticClass: "group-name"
    }, [_vm._v(_vm._s(i.subGroupId.split("~~~")[1]))]), _vm._v(" "), (!i.isReadOnly) ? _c('i', {
      staticClass: "fa fa-plus-circle add-group",
      on: {
        "click": function($event) {
          _vm.addToSelectedIndieGroup(i.subGroupId.split('~~~')[0])
        }
      }
    }) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang["selectedgroups"]))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_vm._l((_vm.uniqueAppsFiltered), function(x) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isChildren(x.applicationId)),
        expression: "isChildren(x.applicationId)"
      }],
      key: x.appGrpId,
      staticClass: "dd-list-item",
      staticStyle: {
        "padding-right": "15px",
        "padding-left": "5px",
        "display": "block",
        "font-weight": "bold"
      }
    }, [_vm._v("\n                        " + _vm._s(x.applicationName) + "\n                        "), _vm._l((_vm.selectedgroups), function(i, index) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (x.applicationId === i.applicationId),
          expression: "x.applicationId === i.applicationId"
        }],
        key: index,
        staticClass: "group-div",
        class: {
          disabled: i.isReadOnly || !_vm.checkSubGroupAllowed(i.subGroupId), bb0: index !== _vm.selectedgroups.length - 1
        },
        staticStyle: {
          "font-weight": "normal"
        }
      }, [_c('div', {
        staticStyle: {
          "pointer-events": "auto",
          "cursor": "default"
        },
        attrs: {
          "data-toggle": i.isReadOnly || !_vm.checkSubGroupAllowed(i.subGroupId) ? 'tooltip' : false,
          "title": _vm.disableSelectedGroups(i.isReadOnly, i.subGroupId),
          "data-original-title": _vm.disableSelectedGroups(i.isReadOnly, i.subGroupId)
        }
      }, [_c('div', {
        staticClass: "group-name"
      }, [_vm._v(_vm._s(i.subGroupName))]), _vm._v(" "), (!i.isReadOnly && _vm.checkSubGroupAllowed(i.subGroupId)) ? _c('i', {
        staticClass: "fa fa-minus-circle remove-group",
        on: {
          "click": function($event) {
            _vm.removeFromSelectedGroup(i.subGroupId)
          }
        }
      }) : _vm._e()])])
    })], 2)
  }), _vm._v(" "), _c('div', {
    staticClass: "dd-list-item",
    staticStyle: {
      "padding-right": "15px",
      "padding-left": "5px",
      "display": "block",
      "font-weight": "bold"
    }
  }, _vm._l((_vm.selectedIndiegroups), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "group-div",
      class: {
        disabled: !_vm.checkSubGroupAllowed(i.subGroupId), bb0: index !== _vm.selectedIndiegroups.length - 1
      },
      staticStyle: {
        "font-weight": "normal"
      }
    }, [_c('div', {
      staticStyle: {
        "pointer-events": "auto",
        "cursor": "default"
      },
      attrs: {
        "data-toggle": !_vm.checkSubGroupAllowed(i.subGroupId) ? 'tooltip' : false,
        "title": _vm.disableSelectedIndieGroups(i.subGroupId),
        "data-original-title": _vm.disableSelectedIndieGroups(i.subGroupId)
      }
    }, [_c('div', {
      staticClass: "group-name"
    }, [_vm._v(_vm._s(i.subGroupId.split("~~~")[1]))]), _vm._v(" "), (_vm.checkSubGroupAllowed(i.subGroupId)) ? _c('i', {
      staticClass: "fa fa-minus-circle remove-group",
      on: {
        "click": function($event) {
          _vm.removeFromSelectedIndieGroup(i.subGroupId, 'indie')
        }
      }
    }) : _vm._e()])])
  })), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "20px",
      "padding": "0px 15px 0px 5px"
    }
  }, _vm._l((_vm.selectedGroupsOutsideAdmin), function(i, index) {
    return _c('div', {
      key: index,
      staticClass: "group-div",
      class: {
        disabled: !_vm.checkSubGroupAllowed(i.subGroupId),
          bb0: index !== _vm.selectedGroupsOutsideAdmin.length - 1
      },
      staticStyle: {
        "font-weight": "normal"
      }
    }, [(i.subGroupId != _vm.onecargillusersgroupid && i.subGroupId != _vm.onecargilladmingroupid) ? _c('div', [_c('div', {
      staticStyle: {
        "pointer-events": "auto",
        "cursor": "default"
      },
      attrs: {
        "data-toggle": !_vm.checkSubGroupAllowed(i.subGroupId) ? 'tooltip' : false,
        "title": _vm.disableSelectedGroupsOutsideAdmin(i.subGroupId),
        "data-original-title": _vm.disableSelectedGroupsOutsideAdmin(i.subGroupId)
      }
    }, [_c('div', {
      staticClass: "group-name"
    }, [_vm._v(_vm._s(i.subGroupName))]), _vm._v(" "), (_vm.checkSubGroupAllowed(i.subGroupId)) ? _c('i', {
      staticClass: "fa fa-minus-circle remove-group",
      on: {
        "click": function($event) {
          _vm.removeFromSelectedIndieGroup(i.subGroupId)
        }
      }
    }) : _vm._e()])]) : _vm._e()])
  }))], 2)])])]), _vm._v(" "), (_vm.isGroupDeleted) ? _c('div', {
    staticClass: "no-group-error"
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.groupCannotBeAssigned) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userAlreadyExists),
      expression: "userAlreadyExists"
    }],
    staticStyle: {
      "margin-top": "10px",
      "cursor": "pointer",
      "text-decoration": "underline",
      "color": "#444444",
      "font-weight": "bold"
    },
    on: {
      "click": function($event) {
        _vm.goToExistingUser()
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.viewuser) + "\n              ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary create-btn",
    class: {
      disabled: _vm.addUserPrimaryEmail === _vm.loggedInUser && _vm.updateToggle
    },
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        _vm.updateToggle ? _vm.updateUser() : _vm.displayActivateModal()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.updateToggle ? _vm.user_lang.update : _vm.user_lang.inviteuser) + "\n                  ")]), _vm._v(" "), _c('span', {
    staticClass: "cancel-btn",
    on: {
      "click": function($event) {
        _vm.goToUserManagement()
      }
    }
  }, [_vm._v(_vm._s(_vm.user_lang.cancel))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShow && !_vm.updateToggle),
      expression: "!isShow && !updateToggle"
    }]
  }, [_c('div', {
    staticClass: "bc"
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.userAdministration))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-size": "44px !important",
      "font-weight": "bold",
      "overflow": "auto",
      "margin-bottom": "20px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.user_lang.userAdministration))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right",
      "margin-top": "-5px"
    }
  }, [(
    _vm.hostName.toLowerCase() === 'localhost:8080' ||
    _vm.hostName.toLowerCase() === 'cargillcustomer.dev.dev-cglcloud.com' ||
    _vm.hostName.toLowerCase() === 'cargillcustomer.stage.cglcloud.in' ||
    _vm.hostName.toLowerCase() === 'identityservices.stage.mycargill.com' ||
    _vm.hostName.toLowerCase() === 'identityservices-deprecated.mycargill.com' ||
    _vm.hostName.toLowerCase().indexOf('identity-deprecated.mycargill') !== -1
  ) ? _c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showBulkUploadWindow(), _vm.clearAddUserFields(), _vm.removeAllNotifications()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.bulkUploadLabel) + "\n                ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary adduser-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        (_vm.isShow = !_vm.isShow), (_vm.updateToggle = false), _vm.clearAddUserFields(), _vm.removeAllNotifications()
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.user_lang.adduser) + "\n                ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userCreationMessage == _vm.user_lang['usercreated']),
      expression: "userCreationMessage == user_lang['usercreated']"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "userCreationMessage"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.userCreationMessage = ''
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.emailsenttouser) + " " + _vm._s(_vm.addUserFirstName) + " " + _vm._s(_vm.addUserLastName) + "\n                "), _c('div', {
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.pendingactivation))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.resetSuccess),
      expression: "resetSuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.resetSuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.resetsuccesspopupmsg))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activateSuccess),
      expression: "activateSuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.activateSuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.user_lang.activatesuccess) + " " + _vm._s(_vm.reverseTransformEmail(_vm.activatedemail)) + "\n              ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.updatesuccess),
      expression: "updatesuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.updatesuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.updatesuccess))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deactivateSuccess),
      expression: "deactivateSuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.deactivateSuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.reverseTransformEmail(_vm.activatedemail)) + " " + _vm._s(_vm.user_lang.deactivatesuccess) + "\n              ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deleteSuccess),
      expression: "deleteSuccess"
    }],
    staticClass: "usercreateinfo",
    attrs: {
      "id": "resetpasswordsuccess"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-close",
    staticStyle: {
      "float": "right",
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.deleteSuccess = false
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "margin": "0px 10px"
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle",
    staticStyle: {
      "font-size": "50px"
    }
  })]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "inline-block",
      "font-size": "14px",
      "font-weight": "bold",
      "vertical-align": "super"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.reverseTransformEmail(_vm.activatedemail)) + " " + _vm._s(_vm.user_lang.deletesuccess) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12",
    class: {
      disabled: _vm.globalsearch
    }
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.filteruser))]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAppId),
      expression: "selectedAppId"
    }],
    staticClass: "dropdown-style",
    attrs: {
      "id": "selectApp"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAppId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filterApp]
    }
  }, _vm._l((_vm.uniqueAppsFiltered), function(app) {
    return _c('option', {
      key: app.appGrpId,
      attrs: {
        "id": app.appGrpId
      },
      domProps: {
        "value": app.applicationId
      }
    }, [_vm._v("\n                        " + _vm._s(app.applicationName) + "\n                      ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12",
    class: {
      disabled: _vm.globalsearch
    }
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.filterusergrp))]), _vm._v(" "), _c('span', {
    staticClass: "report-link",
    on: {
      "click": function($event) {
        _vm.resetTotalCount();
        _vm.downloadUsersOfGroupRecursively();
      }
    }
  }, [_c('progress', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }],
    staticStyle: {
      "width": "100px",
      "height": "7px"
    },
    attrs: {
      "id": "file",
      "max": _vm.reportTotalCount
    },
    domProps: {
      "value": _vm.downloadReportSet.length
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showProgress),
      expression: "showProgress"
    }],
    staticStyle: {
      "font-size": "16px",
      "color": "#000",
      "margin-right": "10px",
      "margin-left": "5px"
    }
  }, [_vm._v(_vm._s(_vm.reportTotalCount ? ((_vm.downloadReportSet.length / _vm.reportTotalCount) * 100).toFixed(0) : "0") + "%")]), _vm._v(_vm._s(_vm.user_lang.reportLabel) + "\n                    "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "16px"
    },
    attrs: {
      "data-v-04fb9444": ""
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedGroupId),
      expression: "selectedGroupId"
    }],
    staticClass: "dropdown-style",
    attrs: {
      "id": "grpdd"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedGroupId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.filterGroup]
    }
  }, _vm._l((_vm.subGroups), function(group) {
    return _c('option', {
      key: group.subGroupId,
      domProps: {
        "value": group.subGroupId
      }
    }, [_vm._v(_vm._s(group.subGroupName))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-6 col-sm-6 col-xs-12"
  }, [_c('div', {
    staticClass: "form-wrap"
  }, [_c('label', {
    staticClass: "form-control-label",
    attrs: {
      "for": "message-text"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.search))]), _vm._v(" "), _c('label', {
    staticClass: "form-control-label",
    staticStyle: {
      "float": "right",
      "min-width": "0px"
    }
  }, [_vm._v(_vm._s(_vm.user_lang.globalsearch))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.globalsearch),
      expression: "globalsearch"
    }],
    staticClass: "gsearch",
    staticStyle: {
      "float": "right",
      "margin-right": "10px"
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.globalsearch) ? _vm._i(_vm.globalsearch, null) > -1 : (_vm.globalsearch)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.globalsearch,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.globalsearch = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.globalsearch = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.globalsearch = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "wrap-input"
  }, [_c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary search-icon"
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "hidden"
    }
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.globalsearch),
      expression: "!globalsearch"
    }],
    staticClass: "searchinfotext"
  }, [_vm._v(_vm._s(_vm.user_lang.searchinfotext))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchTerm),
      expression: "searchTerm"
    }],
    staticClass: "form-control",
    staticStyle: {
      "margin-left": "0px !important",
      "margin-top": "0px",
      "margin-bottom": "0px !important",
      "width": "100% !important"
    },
    attrs: {
      "type": "text",
      "id": "searchId"
    },
    domProps: {
      "value": (_vm.searchTerm)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchTerm = $event.target.value
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row tableContainer",
    staticStyle: {
      "margin-top": "0",
      "border": "0",
      "background": "#eceff1"
    }
  }, [_c('div', {
    staticClass: "card-block1"
  }, [_c('div', {
    staticClass: "tab-pane",
    attrs: {
      "id": "search",
      "role": "tabpanel"
    }
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', {
    staticClass: "search-bar-wrapper"
  }, [_c('div')])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }), _vm._v(" "), _c('UserTable', {
    attrs: {
      "adminAppsArray": _vm.adminAppsArray,
      "filterAppId": _vm.selectedAppId,
      "filterGroupId": _vm.selectedGroupId,
      "usercreated": _vm.userCreationMessage,
      "searchTerm": _vm.searchTerm,
      "globalsearch": _vm.globalsearch,
      "adminTo": _vm.adminTo
    }
  })], 1)])])])])])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-04fb9444", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-04fb9444"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/Admin.vue
// module id = 700
// module chunks = 1